/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	var $window = $(window);
	var windowWidth = $window.width(); // メディアクエリ
	
	var mql = window.matchMedia('screen and (max-width: 1024px)'); //cookie
	
	var _cookieValue = 'v0';
	var _cookieName = 'voted';
	var date = new Date();
	
	var _cookieExpires = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59);
	
	var _cookieValue2 = 'v1';
	var _cookieName2 = 'cheered'; //preload
	
	(0, _module.preload)(); // pageTop
	
	(0, _module.pageTop)(); //showMovie
	
	(0, _module.showMovie)(); //anchorLink
	
	(0, _module.anchorLink)();
	$(window).on('load', function () {
	  scrollIndexAnime(); // voteCookie();
	  // $('.js-Vote').removeClass('close');
	  // $('.js-Cheer').removeClass('close');
	
	  setTimeout(function () {
	    $('#st-Loader').addClass("load");
	  }, 0);
	  setTimeout(function () {
	    $('#st-Loader').addClass("hidden");
	  }, 100);
	  setTimeout(function () {
	    $('#st-Loader').remove();
	  }, 2000);
	}); // ------------------------------------------------------------------------
	// voteCookie
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	var voteCookie = function voteCookie() {
	  // cookie
	  var cookie = $.cookie(_cookieName);
	  var cookie2 = $.cookie(_cookieName2); // タブのパラメータがついている時の対応
	
	  var param = getParam('id');
	
	  if (cookie !== _cookieValue || param == 'test-vote') {
	    // 指定のcookieがブラウザにない場合
	    $('.js-Vote').removeClass('close');
	    console.log('none');
	  } else {
	    // 指定のcookieがブラウザにある場合
	    $('.js-Vote').addClass('close');
	    console.log('voted');
	  }
	
	  if (cookie2 !== _cookieValue2 || param == 'test-vote') {
	    // 指定のcookieがブラウザにない場合
	    $('.js-Cheer').removeClass('close');
	    console.log('none');
	  } else {
	    // 指定のcookieがブラウザにある場合
	    $('.js-Cheer').addClass('close');
	    console.log('cheered');
	  } //投票するボタン
	
	
	  $('.js-Vote').on('click', function () {
	    //cookie
	    $.cookie(_cookieName, _cookieValue, {
	      expires: _cookieExpires
	    });
	    $('.js-Vote').addClass('close');
	  }); //応援するボタン
	
	  $('.js-Cheer').on('click', function () {
	    //cookie
	    $.cookie(_cookieName2, _cookieValue2, {
	      expires: _cookieExpires
	    });
	    $('.js-Cheer').addClass('close');
	  });
	}; // ------------------------------------------------------------------------
	// getParam
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	function getParam(name, url) {
	  if (!url) url = window.location.href;
	  name = name.replace(/[\[\]]/g, "\\$&");
	  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
	      results = regex.exec(url);
	  if (!results) return null;
	  if (!results[2]) return '';
	  return decodeURIComponent(results[2].replace(/\+/g, " "));
	} // ------------------------------------------------------------------------
	// scrollIndexAnime
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	var scrollIndexAnime = function scrollIndexAnime() {
	  var controller = new ScrollMagic.Controller(); // const targets = document.querySelectorAll(".js-scrollAnimation");
	  // const targetsArray = Array.prototype.slice.call(targets); //Array
	  // targetsArray.forEach(target => {
	  // //シーンを作成
	  // const scene = new ScrollMagic.Scene({
	  //     triggerElement: target,
	  //     triggerHook: .8
	  //   })
	  //   .setClassToggle(target, "is-animated")
	  //   .addTo(controller);
	  // });
	  //アンカーリンク
	  // const scene = new ScrollMagic.Scene({
	  //   triggerElement:'#index-Vote',
	  //   triggerHook: 1,
	  //   offset: '-80'
	  // })
	  // .setClassToggle('#vote_Anchor', 'hidden')
	  // .addTo(controller);
	  //バンド背景
	  // const scene2 = new ScrollMagic.Scene({
	  //   triggerElement:'#index-Afterglow',
	  //   triggerHook: 1,
	  //   offset: '0'
	  // })
	  // .setClassToggle('#index-Bg', 'afterglow')
	  // .addTo(controller);
	  //　スクロールで発火系
	
	  var targets = document.querySelectorAll(".js-scrollAnimation");
	  var targetsArray = Array.prototype.slice.call(targets); //Array
	
	  targetsArray.forEach(function (target) {
	    //シーンを作成
	    var scene3 = new ScrollMagic.Scene({
	      triggerElement: target,
	      triggerHook: .8
	    }).setClassToggle(target, "is-animated").addTo(controller);
	  });
	};

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.anchorLink = exports.showMovie = exports.pageTop = exports.preload = void 0;
	
	// ------------------------------------------------------------------------
	// preload
	// ----- BOTH
	// ------------------------------------------------------------------------
	var preload = function preload() {
	  history.replaceState(null, null, null);
	  window.addEventListener('popstate', function () {
	    $('body').addClass('preload');
	    setTimeout(function () {
	      $('body').removeClass('preload');
	    }, 100);
	  }, false);
	  $(window).on('load', function () {
	    $("body").removeClass("preload");
	  });
	}; // ------------------------------------------------------------------------
	// pageTop
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.preload = preload;
	
	var pageTop = function pageTop() {
	  $("#st-Top").on("click", function () {
	    var linkSpeed = 800;
	    $("html, body").animate({
	      scrollTop: 0
	    }, linkSpeed, "easeOutExpo");
	    return false;
	  });
	}; // ------------------------------------------------------------------------
	// showMovie
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.pageTop = pageTop;
	
	var showMovie = function showMovie() {
	  var $modal = $('#sw-Youtube');
	  var $content = $('#sw-Youtube_Content'); // open
	
	  $('.js-Youtube').on('click', function () {
	    var dataID = $(this).attr('data-youtube');
	    $('#sw-Youtube').css({
	      'opacity': '0',
	      'display': 'block'
	    }).stop().animate({
	      'opacity': '1',
	      'width': 100 + '%',
	      'height': 100 + 'vh',
	      'top': 0,
	      'left': 0
	    }, 300, 'easeOutQuart', function () {
	      //iframe append
	      $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/' + dataID + '?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen" frameborder="0"></iframe>'); // fadeIn
	
	      $modal.stop().fadeIn(400);
	      return false;
	    });
	  }); //close
	
	  $('#sw-Youtube_Close,#sw-Youtube_Overlay').on('click', function () {
	    $('#sw-Youtube').css({
	      'opacity': '1'
	    }).stop().animate({
	      'opacity': '0'
	    }, 300, 'easeOutQuart', function () {
	      $('#sw-Youtube').css({
	        'display': 'none'
	      });
	      $content.children('iframe').remove();
	    });
	  });
	}; // ------------------------------------------------------------------------
	// anchorLink
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.showMovie = showMovie;
	
	var anchorLink = function anchorLink() {
	  //ページ外からのページ内リンク
	  var urlHash = location.hash;
	
	  if (urlHash) {
	    $('body,html').stop().scrollTop(0);
	    setTimeout(function () {
	      var target = $(urlHash);
	      var position = target.offset().top - 0;
	      $('body,html').stop().animate({
	        scrollTop: position
	      }, 500);
	    }, 200);
	  }
	
	  var linkSpeed = 800;
	  var linkAdjust = 90; //ページ内リンク
	
	  $("a[href^='#']").on("click", function () {
	    var linkHref = $(this).attr("href");
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkPosition = linkTarget.offset().top;
	    $("html, body").animate({
	      scrollTop: linkPosition + linkAdjust
	    }, linkSpeed, "easeInOutQuint");
	    return false;
	  });
	};
	
	exports.anchorLink = anchorLink;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index/app.bundle.js